import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Hook custom pour affecter manuellement une ou plusieurs étapes à un véhicule
 *
 * Retourne:
 * - assignStep: fonction pour lancer l'affectation
 * - isAssigning: état de chargement
 * - error: erreur éventuelle
 * - resetError: fonction pour réinitialiser l'erreur
 */
const useAssignStep = () => {
  const [isAssigning, setIsAssigning] = useState(false);
  const [error, setError] = useState(null);

  const assignStep = useCallback(async ({ tourPlanningIds, vehicleKey, tourDate, optimize = true } = {}) => {
    setIsAssigning(true);
    setError(null);

    try {
      if (!tourPlanningIds || tourPlanningIds.length === 0) {
        throw new Error('Au moins une étape est requise pour l\'affectation.');
      }

      if (!vehicleKey) {
        throw new Error('La clé du véhicule est requise pour l\'affectation.');
      }

      if (!tourDate) {
        throw new Error('La date de tournée est requise pour l\'affectation.');
      }

      const response = await fleetApi.post('/tours-planning/steps/assign', {
        tour_planning_ids: tourPlanningIds,
        vehicle_key: vehicleKey,
        tour_date: tourDate,
        optimize: optimize, // Envoyer l'option d'optimisation au backend
      });

      if (response.status === 200) {
        return {
          success: true,
          message: response.data?.message || 'Commande affectée avec succès.',
          data: response.data?.data,
        };
      }

      throw new Error(response.data?.message || 'Erreur lors de l\'affectation.');
    } catch (err) {
      const message =
        err?.response?.data?.message || err.message || "Impossible d'affecter la commande.";
      setError(message);
      return { success: false, message };
    } finally {
      setIsAssigning(false);
    }
  }, []);

  const resetError = useCallback(() => {
    setError(null);
  }, []);

  return {
    assignStep,
    isAssigning,
    error,
    resetError,
  };
};

export default useAssignStep;


